import { jsx as _jsx } from "react/jsx-runtime";
import { PaymentGroupName } from '@as-react/common-types';
import { PaymentGroupContent } from './PaymentGroupContent';
import { useSavePaymentOption } from '../../../../hooks/useSavePaymentOption';
import { useCheckoutConfig } from '../../../../context/CheckoutContext';
import { usePaymentState } from '../../../../context/CheckoutPaymentContext';
export const PaymentGroupGeneric = ({ disabled, group, selected }) => {
    const { savePaymentOptions, errorMessage, isLoading } = useSavePaymentOption();
    const { payPalInfoMessage } = useCheckoutConfig();
    const [{ optionError }] = usePaymentState();
    const optionSelectError = optionError[group.name];
    const hint = group.name === PaymentGroupName.PAYPAL ? payPalInfoMessage : undefined;
    return (_jsx(PaymentGroupContent, { onSubmit: () => savePaymentOptions({ group }), disabled: disabled, isSubmitting: isLoading, error: errorMessage || optionSelectError, selected: selected, hint: hint, group: group }));
};
